<template>
  <div class="cart section fullscreen-content">
    <h1 class="section-title centered" v-if="['xs', 'sm', 'ms', 'md'].includes($mq) && $store.state.cart.items.length">
      CART</h1>
    <div class="container">
      <div class="row c-nb" v-if="$store.state.cart.items.length">
        <div class="col-8 col-md-12 cart-items">
          <div class="cart-item" v-for="(item, key) in $store.state.cart.items" :key="key">
            <mq-layout class="product-title mobile-title" :mq="['xs', 'sm', 'ms', 'md']">
              <h2>
                <router-link
                    :to="{name: 'product', params: {product: item.product_id}}"
                >{{ item.title }}
                </router-link>
              </h2>
              <span class="icon-trash" @click="removeItem(item)"></span>
            </mq-layout>
            <div class="product-image">
              <img :src="item.image" alt/>
            </div>
            <div class="product-details">
              <mq-layout class="product-title" :mq="['lg', 'xl', 'hd', 'inf']">
                <h2>
                  <router-link
                      :to="{name: 'product', params: {product: item.product_id}}"
                  >{{ item.title }}
                  </router-link>
                </h2>
                <span class="icon-trash" @click="removeItem(item)"></span>
              </mq-layout>
              <div class="product-information">
                <dl>
                  <dt>{{ $t('shop.cart.price') }}</dt>
                  <dd>{{ item.price }} AMD</dd>
                  <dt>{{ $t('shop.cart.subtotal') }}</dt>
                  <dd>{{ item.price * item.qty }} AMD</dd>
                  <dt>{{ $t('shop.cart.sku') }}՝</dt>
                  <dd>{{ item.sku }}</dd>
                </dl>
                <dl v-if="['lg', 'xl', 'hd', 'inf'].includes($mq)">
                  <dt>{{ $t('shop.cart.qty') }}</dt>
                  <dd>
                    <quantity @changeQty="changeQty" :item="item"></quantity>
                  </dd>
                  <template v-for="(attr, key) in item.attributes">
                    <div :key="key">
                      <dt>{{ key }}:</dt>
                      <dd>
                        <component :is="key" :attr="attr"></component>
                      </dd>
                    </div>
                  </template>
                </dl>
              </div>
            </div>
            <div class="product-mobile-option" v-if="['xs', 'sm', 'ms', 'md'].includes($mq)">
              <ul>
                <li>
                  <span>{{ $t('shop.cart.qty') }}</span>
                  <div>
                    <quantity @changeQty="changeQty" :item="item"></quantity>
                  </div>
                </li>
                <template v-for="(attr, key) in item.attributes">
                  <li :key="key">
                    <span>{{ key }}:</span>
                    <div>
                      <component :is="key" :attr="attr"></component>
                    </div>
                  </li>
                </template>
              </ul>
            </div>
          </div>
        </div>
        <div class="col-4 col-md-12">
          <Summary :shipping_method="{}"></Summary>
          <div class="checkout-action-btn">
            <button class="button" @click="checkout()">{{ $t('shop.checkout.checkout') }}</button>
            <router-link :to="$i18nRoute({name: 'pages', params: {page: 'return-terms'}})">
              {{ $t('shop.cart.return_terms') }}
            </router-link>
          </div>
        </div>
      </div>
      <div class="notification" v-else>
        <h1>{{ $t('shop.cart.cart_empty') }}</h1>
        <p>
          <router-link :to="$i18nRoute({name: 'shop'})" class="reset-filters">{{ $t('shop.cart.continue_shopping') }}
          </router-link>
        </p>
      </div>
    </div>
  </div>
</template>

<script>
import Quantity from '@/components/shop/Quantity.vue';
import Color from '@/components/shop/cart/attributes/Color.vue';
import Size from '@/components/shop/cart/attributes/Size.vue';
import Summary from '@/components/shop/cart/Summary.vue';
import { mapActions } from 'vuex';

export default {
  components: {
    Quantity,
    Color,
    Size,
    Summary
  },
  name: 'cart',
  data () {
    return {
      quantity: 1
    };
  },
  mounted () {
    this.updatePricesInterval = setInterval(() => {
      this.$store.dispatch('updateCartPrices');
    }, 5000); // 1 minute
  },
  beforeDestroy () {
    clearInterval(this.updatePricesInterval);
  },
  methods: {
    ...mapActions(['updateCartPrices']),

    fetchCartItems () {
      this.$store.state.cart.items.forEach(item => {
        this.$store.dispatch('fetchCartItemQty', item);
      });
    },
    changeQty (item) {
      this.$store.dispatch('fetchCartItemQty', item);
    },
    removeItem (item) {
      this.$store.dispatch('removeCartItemQty', item);
    },
    checkout () {
      this.fetchCartItems();
      this.$router.push({ name: 'checkout' });
    }
  }
};
</script>

<style lang="scss">
.cart {
  padding-top: 130px;

  @include mq($ms) {
    padding-top: 105px;
  }

  .cart-empty {
    padding: 30px;
    text-transform: uppercase;
    text-align: center;
    max-width: 500px;
    box-shadow: 0px 0px 7px 0px rgba(0, 0, 0, 0.12);
    margin: auto;
    margin-top: 100px;

    a {
      padding-top: 15px;
      font-size: 14px;
      color: #a09a9a;
      display: inline-block;
    }
  }

  .cart-items {
    .cart-item {
      display: flex;
      padding: 15px;
      border: 1px solid #ededed;

      @include mq($md) {
        flex-wrap: wrap;
      }

      .mobile-title {
        width: 100%;

        .icon-trash {
          top: 8px !important;
        }
      }

      &:not(:last-child) {
        margin-bottom: 15px;
      }

      &:hover {
        box-shadow: 0 0 5px rgba(0, 0, 0, 0.1);
      }

      .product-title {
        position: relative;

        h2 {
          font-size: 24px;
          font-family: $font-bold;
          margin-top: 0;
          margin-bottom: 15px;

          @include mq($ms) {
            font-size: 18px;
          }
        }

        .icon-trash {
          position: absolute;
          right: 0;
          top: 0;
          cursor: pointer;
        }
      }

      .product-image {
        position: relative;
        width: 160px;
        height: 160px;
        flex: 0 0 auto;

        @include mq($md) {
          width: 140px;
          height: 140px;
        }

        &:before {
          content: "";
          padding-top: 100%;
          display: block;
        }

        img {
          position: absolute;
          top: 0;
          width: 100%;
          height: 100%;
          object-fit: cover;
        }
      }

      .product-details {
        flex: 0 1 auto;
        width: 100%;
        padding-left: 30px;

        @include mq($md) {
          padding-left: 15px;
          width: calc(100% - 140px);
          flex: 0 0 auto;
        }

        .product-information {
          display: flex;
          flex-wrap: wrap;

          dl {
            display: flex;
            flex-basis: 50%;
            flex-flow: row wrap;
            font-size: 16px;
            margin: 0;

            @include mq($ms) {
              flex-basis: 100%;
              display: block;
              font-size: 14px;
            }
          }

          dt {
            flex-basis: 50%;
            padding: 2px 4px;
            color: #7f7f7f;
            margin-bottom: 5px;
            @include mq($md) {
              margin-bottom: 0;
            }
          }

          dd {
            flex-basis: 50%;
            flex-grow: 1;
            margin: 0;
            padding: 2px 4px;
            margin-bottom: 5px;
            @include mq($ms) {
              margin-bottom: 0;
            }
          }
        }
      }

      .size-value,
      .color-value {
        width: 30px;
        height: 30px;
        line-height: 30px;
        text-align: center;
        font-size: 12px;
        border: 1px solid $main-color;
      }

      .color-value {
        box-shadow: inset 0px 0px 0px 6px #fff;
      }

      .product-mobile-option {
        width: 100%;
        margin-top: 15px;

        ul {
          padding: 0;
          margin: 0;
          display: flex;
          font-size: 14px;

          li {
            margin-right: 15px;

            &:first-child {
              width: 145px;
            }

            span {
              display: block;
              color: #7f7f7f;
              margin-bottom: 5px;
            }
          }
        }
      }
    }
  }
}
</style>
